import { useCallback } from 'react';
import { cleanEmojieValue, containsEmoji } from 'helpers';

const useEmojiPrevention = () => {
  const handleKeyDown = useCallback((e) => {
    if (containsEmoji(e.key)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, []);

  const handlePaste = useCallback((e) => {
    const pastedText = e.clipboardData.getData('text');
    if (containsEmoji(pastedText)) {
      e.preventDefault();
      const cleanText = cleanEmojieValue(pastedText);
      const currentValue = e.target.value;
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;
      const newValue = currentValue.substring(0, selectionStart) + cleanText + currentValue.substring(selectionEnd);

      e.target.value = newValue;
      
      const inputEvent = new Event('input', { bubbles: true });
      e.target.dispatchEvent(inputEvent);
    }
  }, []);

  const handleInput = useCallback((e, setQuery) => {
    const cleanValue = cleanEmojieValue(e.target.value);
    if (cleanValue !== e.target.value) {
      e.target.value = cleanValue;
    }
    setQuery(cleanValue);
  }, []);

  const getInputProps = useCallback((params, setQuery) => ({
    ...params.inputProps,
    onKeyDown: handleKeyDown,
    onPaste: handlePaste,
    onInput: (e) => handleInput(e, setQuery)
  }), [handleKeyDown, handlePaste, handleInput]);

  return {
    handleKeyDown,
    handlePaste,
    handleInput,
    getInputProps
  };
};

export default useEmojiPrevention;
